export default __webpack_public_path__ + "static/media/camera.19ab91f7.svg";